import { render, staticRenderFns } from "./updEvents.vue?vue&type=template&id=6f66a9bb&scoped=true&"
import script from "./updEvents.vue?vue&type=script&lang=js&"
export * from "./updEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f66a9bb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f66a9bb')) {
      api.createRecord('6f66a9bb', component.options)
    } else {
      api.reload('6f66a9bb', component.options)
    }
    module.hot.accept("./updEvents.vue?vue&type=template&id=6f66a9bb&scoped=true&", function () {
      api.rerender('6f66a9bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/retentionAnalysis/components/updEvents.vue"
export default component.exports